// @flow

import { UPDATE_SORT } from '../constants';
import type { UpdateSort } from '../actions';
import { getDefaultSortOption } from '../config';
import type { Sort } from '../types';

type SortState = Sort;

const {
  direction,
  property,
  type,
} = getDefaultSortOption();

const initialState: SortState = {
  direction,
  property,
  type: type || 'string',
};

const sort = (
  state: SortState = initialState,
  action: UpdateSort,
): SortState => {
  switch (action.type) {
    case UPDATE_SORT:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default sort;
